export const DO_ACTION_REQUEST = "@OPERATIONS/DO_ACTION_REQUEST";
export const DO_ACTION_SUCCESS = "@OPERATIONS/DO_ACTION_SUCCESS";
export const DO_ACTION_FAILURE = "@OPERATIONS/DO_ACTION_FAILURE";
